export const defaultLocale = {
  flag: "🇫🇷",
  id: 0,
  iso_code: "fr_FR",
  iso_code_639: "fr-FR",
  label: "language_french",
}

export const i18nNamespaces = [
  "general",
  "accessibility",
  "assessment",
  "candidate_account",
  "language",
  "data_jobs",
  "swipe",
  "shape",
  "drive",
  "brain",
  "move",
  "movebis",
  "onboarding",
  "pole_emploi",
  "error",
  "voice",
  "skills",
  "language",
  "scan",
]
